import css from './image-card.module.scss';
import classNames from 'classnames';

interface Props {
  title: string;
  className?: string;
  imgUrl: string;
  onClick: () => void;
}

function ImageCard({ title, className, imgUrl, onClick }: Readonly<Props>) {
  return (
    <div className={classNames(css.imageCard, className ? css[className] : '')} onKeyDown={onClick} onClick={onClick}>
      <div className={css.blur}>
        <h3>{title}</h3>
      </div>
      <img src={imgUrl} alt={imgUrl} />
    </div>
  );
}

export default ImageCard;
